import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "input-items" }
const _hoisted_2 = ["value", "checked"]

import {IRadioboxField} from "~/cabinet/vue/interface/form/elements/Interfaces";
import ChatHtmlify from "~/chat/vue/misc/ChatHtmlify.vue";
import ChatFormInlineSvgIcon from "~/chat/vue/widget/form/fields/ChatFormInlineSvgIcon.vue";
import {useChatFormInput, useChatFormInputProps} from "~/chat/vue/widget/form/fields/useChatFormInput";
import {nextTick} from "vue";


const __default__ = {
    name: "ChatRadioInput"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    ...useChatFormInputProps<IRadioboxField>()
},
  emits: ["update:modelValue"],
  setup(__props, { expose: __expose, emit: __emit }) {

let props = __props;

let emits = __emit;

let {exposedObject, placeholder} = useChatFormInput(props);

__expose(exposedObject);

function isChecked(value: any) {
    if (props.modelValue != null) {
        return props.modelValue === value;
    } else {
        let defaultValue = props.field.options.find(item => item.default);

        if (defaultValue && defaultValue.value === value) {
            nextTick(() => {
                emits("update:modelValue", value)
            });
        }
    }
    return false;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({
        'like-input': true,
        error: _ctx.error
    })
  }, [
    _createElementVNode("div", null, [
      _createVNode(ChatFormInlineSvgIcon, { field: _ctx.field }, null, 8, ["field"]),
      _createTextVNode(" " + _toDisplayString(_unref(placeholder)), 1)
    ]),
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.field.options, (item, index) => {
        return (_openBlock(), _createElementBlock("label", {
          key: index,
          class: "cursor-pointer"
        }, [
          _createElementVNode("input", {
            type: "radio",
            value: item.value,
            checked: isChecked(item.value),
            onChange: _cache[0] || (_cache[0] = ($event: any) => (_unref(emits)('update:modelValue', $event.target.value)))
          }, null, 40, _hoisted_2),
          _createVNode(ChatHtmlify, {
            links: "",
            value: item.descr
          }, null, 8, ["value"])
        ]))
      }), 128))
    ])
  ], 2))
}
}

})